import { render, staticRenderFns } from "./CardFileUpload.vue?vue&type=template&id=24bb3609&scoped=true&"
import script from "./CardFileUpload.vue?vue&type=script&lang=js&"
export * from "./CardFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./CardFileUpload.vue?vue&type=style&index=0&id=24bb3609&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bb3609",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VFileInput,VIcon,VProgressLinear,VRow,VSkeletonLoader,VTooltip})
